import useCompany, {
  CompanyOptions,
  CompanyVars,
} from '@vangst/services/oogst/company/useCompany'
import { PageType } from '@vangst/services/oogst/page'
import { RobotsEnum } from '@vangst/services/oogst/types'
import React from 'react'
import Meta, { CrumbType } from '../application/Meta'

type PropsType = {
  readonly page: PageType | null
  readonly crumbs: ReadonlyArray<CrumbType>
  readonly variables: CompanyVars
  readonly options?: CompanyOptions
}

function CompanyMeta(props: PropsType) {
  const { crumbs, page, variables, options } = props
  const { data } = useCompany(variables, options)
  const company = data?.getClient

  // TODO: Move to derivedCompany?
  const derived = React.useMemo(() => {
    const metaTitle =
      company?.metaTitle && company.metaTitle.length
        ? company.metaTitle
        : `${company?.name || company?.displayname} ${
            company?.citystate?.length ? 'in' : ''
          } ${company?.citystate} | Vangst`
    const metaDescription =
      company?.metaDescription && company.metaDescription?.length
        ? company.metaDescription
        : `${company?.name} and other top cannabis companies are hiring in areas ${
            company?.citystate?.length ? 'like ' + company?.citystate : ''
          } for cannabis jobs through Vangst. Find job listings, cannabis education and trainings, and network with companies near you.`

    return {
      metaTitle,
      metaDescription,
    }
  }, [company])

  return (
    <Meta
      key="meta"
      canonicalUrl={page?.metaInfo.canonicalUrl}
      crumbs={crumbs}
      description={page?.metaInfo.description ?? derived.metaDescription}
      robots={
        page?.metaInfo.robots ??
        (company?.visibleOnPlatform
          ? RobotsEnum.IndexFollow
          : RobotsEnum.NoindexNofollow)
      }
      title={page?.metaInfo.title ?? derived.metaTitle}
    />
  )
}

export default React.memo(CompanyMeta)
